<template>
    <div class="tw-relative">
        <span
            v-if="model === undefined && placeholder"
            class="tw-absolute tw-font-system tw-top-[10px] tw-left-4 tw-text-sm tw-text-gray-400 tw-mb-[5px] tw-block tw-z-[-1]"
            :class="{
                '!tw-text-white/50': glass,
            }"
            @click="selectInput()"
        >
            {{ placeholder }}
        </span>
        <select
            :id="id"
            ref="input"
            v-model="model"
            class="tw-px-3.5 tw-py-1.5 tw-rounded-md tw-w-full tw-bg-white tw-text-gray-900 tw-text-sm tw-leading-5 tw-border tw-border-gray-300 tw-cursor-pointer tw-transition-colors tw-duration-150 hover:tw-border-gray-400 focus:tw-border-gray-600 focus:tw-ring-0 focus:tw-outline-none disabled:tw-border-gray-200 disabled:tw-bg-gray-50 disabled:tw-cursor-default"
            :class="[
                inputClass,
                {
                    'tw-bg-transparent': model === undefined && placeholder,
                    '!tw-bg-white/10 !tw-text-white !tw-border-white/30 hover:!tw-bg-white/15 hover:!tw-border-white/50 focus:!tw-bg-white/15 focus:!tw-border-white/70':
                        glass,
                },
            ]"
            :disabled="disabled || loading"
            :multiple="multiple"
            :size="size"
            :required="required"
            :name="name"
            :placeholder="placeholder"
        >
            <slot></slot>
        </select>
        <span v-if="error" class="tw-text-red-500">
            {{ typeof error === 'string' ? error : error[0] }}
        </span>
        <ContainedLoader v-if="loading" />
    </div>
</template>
<script setup lang="ts" generic="TModel extends string | number | Array<unknown> | null | undefined">
import { useTemplateRef } from 'vue';
import ContainedLoader from '@/js/components/controls/ContainedLoader.vue';

defineProps({
    id: {
        type: String,
        default: null,
    },
    disabled: {
        type: Boolean,
        default: false,
    },
    placeholder: {
        type: String,
        default: 'Select an option',
    },
    multiple: {
        type: Boolean,
        default: false,
    },
    size: {
        type: String,
        required: false,
    },
    required: {
        type: Boolean,
        default: false,
    },
    loading: {
        type: Boolean,
        default: false,
    },
    inputClass: {
        type: String,
        default: null,
    },
    name: {
        type: String,
        required: false,
        default: null,
    },
    error: {
        type: [Array, String],
        default: null,
    },
    glass: {
        type: Boolean,
        default: false,
    },
});

const model = defineModel<TModel | null>({
    default: null,
});
const input = useTemplateRef('input');

const selectInput = () => {
    input.value?.focus();
};
</script>
